import { render, staticRenderFns } from "./AddMembers.vue?vue&type=template&id=997c503e&"
import script from "./AddMembers.vue?vue&type=script&lang=js&"
export * from "./AddMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports